import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsMissionsActive = () => {
  return useIsFeatureActive('ab_missions_rollout').isActive;
};
